import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

const licenseKey: string =
  'CompanyName=AgrigateOne,LicensedApplication=AgrigateOne,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=3,LicensedProductionInstancesCount=1,AssetReference=AG-037047,SupportServicesEnd=23_January_2024_[v2]_MTcwNTk2ODAwMDAwMA==e256a14595b6e44fe5ea968a98fcccc5';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(licenseKey);
